import achievementData from '../../api/achievements';
import * as types from '../mutation-types';
import Achievement from '../../classes/achievement';
/* eslint-disable indent */
const stateData = {
          all: []
      },
      getters   = {
          allAchievements: s => s.all
      },
      actions   = {
          getAllAchievements({ commit }) {
              achievementData.getAchievements(achievements => {
                  commit(types.RECEIVE_ACHIEVEMENTS, { achievements });
              });
          }
      },
      mutations = {
          [types.RECEIVE_ACHIEVEMENTS](state, { achievements }) {
              if (state.all.length > 0 && !(state.all[0] instanceof Achievement)) {
                  state.all.forEach(loaded => {
                      let match = achievements.find(m => m.id === loaded.id);
                      if (typeof match !== 'undefined') {
                          match.merge(loaded);
                      }
                  });
              }
              state.all = achievements;
          },
          [types.ACHIEVE](state, { achievement }) {
              state.all.find(a => a.id === achievement.id).achieve();
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
